import { Order } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

export type ProductDetails = {
  chainProductId: number
  price: bigint
  stock: number
  perCustomerLimit: number
}

type ProductDetailsState = {
  ordersHistory: Order[]
  isOrdersHistoryFetching: boolean
}

const initialState: ProductDetailsState = {
  ordersHistory: [],
  isOrdersHistoryFetching: true,
}

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    // Adds new items from the payload to the current donation history
    mergeOrdersHistory: (
      immerState,
      { payload: incoming }: { payload: Order[] },
    ) => {
      if (immerState.ordersHistory.length === 0) {
        immerState.ordersHistory = incoming
        return
      }

      const merged = [
        ...incoming.filter(
          (incomingOrder) =>
            !immerState.ordersHistory.some(
              (order) =>
                order.transactionHash === incomingOrder.transactionHash,
            ),
        ),
        ...immerState.ordersHistory,
      ] as Order[]

      immerState.ordersHistory = merged
    },
    addNewOrderToHistory: (immerState, { payload }: { payload: Order }) => {
      immerState.ordersHistory = [payload, ...immerState.ordersHistory]
    },
    setIsOrdersHistoryFetching: (
      immerState,
      { payload }: { payload: boolean },
    ) => {
      immerState.isOrdersHistoryFetching = payload
    },
    resetStoreState: () => initialState,
  },
})

export const {
  mergeOrdersHistory,
  addNewOrderToHistory,
  setIsOrdersHistoryFetching,
  resetStoreState,
} = storeSlice.actions

export default storeSlice.reducer
